/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * This function parse the filters into stringified string.
 */
export const parseFilter = (filter: {
  [key: string]: any;
}): { [key: string]: string } => {
  const fields = Object.keys(filter);
  const parsedFilter: { [key: string]: string } = {};

  fields.forEach((field) => {
    parsedFilter[field] = JSON.stringify(filter[field]);
  });

  return parsedFilter;
};
